document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.faq__item');

  document.querySelectorAll('.faq__question').forEach(button => {
    button.addEventListener('click', () => {
      const faqItem = button.closest('.faq__item');
      const answer = faqItem.querySelector('.faq__answer');

      if (faqItem.classList.contains('open')) {
        answer.style.height = answer.scrollHeight + 'px';
        requestAnimationFrame(() => {
          answer.style.height = '0';
        });
        faqItem.classList.remove('open');
        return;
      }

      items.forEach(item => {
        if (item !== faqItem) {
          const ans = item.querySelector('.faq__answer');
          if (item.classList.contains('open')) {
            ans.style.height = ans.scrollHeight + 'px';
            requestAnimationFrame(() => {
              ans.style.height = '0';
            });
            item.classList.remove('open');
          }
        }
      });

      faqItem.classList.add('open');
      answer.style.height = answer.scrollHeight + 'px';
      answer.addEventListener('transitionend', () => {
        if (faqItem.classList.contains('open')) {
          answer.style.height = 'auto';
        }
      }, { once: true });
    });
  });
});
